var propertyLimits = {
    sources: "numberOfSourcesLimit",
    groups: "numberOfGroupsLimit",
    models: "numberOfModelsLimit",
    apiKeys: "numberOfApiKeysLimit",
    queryPipelines: "maxPipelinesLimit",
    fields: "numberOfFieldsLimit",
    extensions: "licenseExtensionsLimit",
    customDimensions: "customDimensionLimit",
    catalogs: "catalogLimit",
    projects: "numberOfProjectsLimit"
};
var ITDEnable = "intelligentTermDetectionEnabled";
var SITECORE_LICENSES = [
    "SitecoreCloudStandardEdition",
    "SitecoreCloudStandardEditionTrial"
];
var isIpxEnabled = "ipxEnabled";
export var LicenseConstants = {
    propertyLimits: propertyLimits,
    ITDEnable: ITDEnable,
    SITECORE_LICENSES: SITECORE_LICENSES,
    isIpxEnabled: isIpxEnabled
};

//# sourceMappingURL=LicenseConstants.js.map